// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { TerminalNode_abstract } from './../abstract/SagaBase/TerminalNode_abstract';
export class TerminalNode extends TerminalNode_abstract {}
